import React from 'react'
import styles from './pupils-search.styles'
import injectSheet from 'react-jss'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import Button from 'pobble-components/dist/button'

const PupilsSearch = ({
  classes,
  searchValue,
  searchValueChange,
  disabled,
  value
}) => (
  <div className={classes.container}>
    <FormInput
      disabled={disabled}
      onChange={e => searchValueChange(e.target.value)}
      className={classes.input}
      id="pupilSearch"
      placeholder="Type a pupil’s name…"
      inputProps={{ defaultValue: searchValue }}
    />
    <Button disabled={disabled} className={classes.button} tall>
      <label className={classes.buttonLabel} htmlFor="pupilSearch">
        Search for pupil
      </label>
    </Button>
  </div>
)

export default injectSheet(styles)(PupilsSearch)
